import React from 'react'
import Header from './components/header/Header';
import About from './components/about/About';
import Programs from './components/programs/Programs';
import Testimonials from './components/testimonials/Testimonials';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

export default function App() {
  return (
    <>
    <Header />
    <About />
    <Programs />
    <Testimonials />
    <Contact />
    <Footer />
    </>
  )
}
